export default __webpack_public_path__ + "static/media/NoData.09e25109.svg";